import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './styles/global.css';
import ReactGA from 'react-ga4';
import Throbber from 'components/organisms/Throbber';
import * as Sentry from '@sentry/browser';
import * as serviceWorker from './serviceWorker';
import packageJson from '../package.json';

const ReduxWrapper = lazy(() => import('./Root'));
const { version } = packageJson;

// HelmetProviderのためのコンテキストを作成
const helmetContext = {};

// Sentry初期化（DSNが設定されている場合のみ）
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
  normalizeDepth: 10,
  environment: import.meta.env.MODE,
  release: version,
  // debug: 'off',
  beforeSend(event, hint) {
    // https://github.com/getsentry/sentry-react-native/issues/391#issuecomment-431344211
    if (
      event.message &&
      event.message.startsWith('Non-Error exception captured') &&
      hint?.originalException
    ) {
      Sentry.withScope(scope => {
        scope.setExtra('nonErrorException', true);
        Sentry.captureException(hint?.originalException);
      });

      return null;
    }
    const { breadcrumbs = [] } = event;

    return {
      ...event,
      breadcrumbs: breadcrumbs.filter(
        breadCrumb => breadCrumb.category !== 'console',
      ),
    };
  },
  });
}

// Initialize GA4
ReactGA.initialize('G-S1K76F40V7');

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(container);

root.render(
  <Suspense
    fallback={
      <div
        style={{
          background: '#ffd800',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: ' 100vh',
        }}
      >
        <Throbber />
      </div>
    }
  >
    <HelmetProvider context={helmetContext}>
      <ReduxWrapper />
    </HelmetProvider>
  </Suspense>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
